import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AtxNavService } from '../services/atx-nav.service';

@Component({
    selector: 'atx-nav',
    template: `<nav class="navbar navbar-expand-md navbar-{{ color }}">
    <atx-router-tabs *ngIf="routes"
                     [clazz]="'navbar-nav'"
                     [count]="2"
                     [routes]="routes">
    </atx-router-tabs>
</nav>
`,
    styles: [`.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{background:#fff}`],
    encapsulation: ViewEncapsulation.None,
})

export class AtxNavComponent implements OnInit {
    public routes;

    constructor(
        private readonly router: Router,
        private readonly service: AtxNavService,
    ) {}

    public ngOnInit() {
        const primary = this.service.getPrimaryPath();
        const element = this.router.config.find((data: any) => data.path === primary);

        this.routes = element && element.children;
    }
}
